import React, { useCallback } from 'react';
import { IconTrash } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import { muteAll, useFetchOld } from 'hooks/useFetch';
import { deleteTransaction } from 'actions/transactions';
import { getBankConnections } from 'actions/connections';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import Modal from 'utils/packages/Modal';
import useRefreshAccounts from 'hooks/useRefreshAccounts';
import { selectAccountById } from 'reducers/selectors';
const strings = {
    confirmTitle: 'Delete transaction',
    confirmSubtitle: 'Would you like to delete this transaction?',
    confirmYes: 'Yes, let me delete',
    confirmNo: 'No, thanks',
    label: 'Delete this transaction',
};
const TransactionDeleteItem = ({ transaction }) => {
    const [, , , fetch] = useFetchOld(muteAll);
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const store = useAppStore();
    const canDelete = 'provider' in transaction && transaction?.provider === 'MANUAL';
    const refreshAccounts = useRefreshAccounts();
    const account = useAppSelector((state) => selectAccountById(state, transaction.accountId));
    const onDeletePressed = useCallback(() => {
        if (!canDelete)
            return;
        Modal.showConfirmation({
            title: strings.confirmTitle,
            subtitle: strings.confirmSubtitle,
            cancelButtonTitle: strings.confirmNo,
            confirmButtonTitle: strings.confirmYes,
            onConfirm: async () => {
                const state = store.getState();
                const previousState = {
                    transactionsArray: state.transactions.transactionsArray,
                    transactionDeleted: state.transactions.transactionDeleted || null,
                    searchTransactions: state.transactions.searchTransactions,
                };
                await fetch(deleteTransaction(transaction.id, previousState));
                if (account?.type) {
                    refreshAccounts(account?.type);
                }
                else {
                    dispatch(getBankConnections());
                }
                navigation.goBack();
            },
        });
    }, [account?.type, canDelete, refreshAccounts, transaction.id]);
    if (!canDelete) {
        return null;
    }
    return (<SettingsItem icon={<IconTrash />} title={strings.label} onPress={onDeletePressed}/>);
};
export default TransactionDeleteItem;
